<template>
  <div>
    <v-app-bar app light flat color="white" class="appBar">
      <v-toolbar-title
        v-if="widthNow > 550"
        @click="$router.push('/')"
        :style="{ marginLeft: marginLeft }"
      >
        <img
          class="dkLogo"
          :src="require('../../assets/dompetkilat.png')"
          alt="John"
        />
      </v-toolbar-title>
      <v-toolbar-title v-if="widthNow > 1125" class="tkbContainer">
        <v-row>
          <span class="tkbText">TKB90:</span>
        </v-row>
        <v-row>
          <span v-if="masterData.tkb" class="tkbPercentage">
            {{ masterData.tkb + "%" }}
          </span>
          <span v-else class="tkbPercentage">99.63%</span>
        </v-row>
      </v-toolbar-title>

      <v-toolbar-title v-if="widthNow > 550">
        <!-- <v-button
          @click="download('https://smma.dompetkilat.id:3015/api/download', 'DompetKilat_v3.0.apk')"
        >
          <img class="dkLogo" :src="require('../../assets/dompetkilat.png')" alt="John" />
        </v-button> -->
      </v-toolbar-title>
      <!-- href="../../assets/application/DompetKilat_v3.0.apk" download -->

      <v-spacer />
      <!-- <div :class="{ borderNavButton: $route.name == 'Pendanaan' }">
        <v-btn
          plain
          x-small
          class="navButton text-capitalize"
          :ripple="false"
          :class="{
            'grey--text text--darken-2': $route.name != 'Pendanaan',
          }"
          color="#252525"
          v-if="widthNow > 550"
          @click="$router.push({ path: 'pendanaan' })"
        >
          <p>Pendanaan</p>

          <p />
        </v-btn>
      </div> -->
      <!-- <div v-else>
        <v-btn
          plain
          x-small
          class="navButton text-capitalize"
          color="#252525"
          v-if="widthNow > 550"
          @click="$router.push({ path: 'pendanaan' })"
        >
          <p>Pendanaan</p>

          <p />
        </v-btn>
      </div>-->

      <!-- <div class="btnSpacer" /> -->

      <!-- <div :class="{ borderNavButton: $route.name == 'Pinjaman' }">
        <v-btn
          plain
          x-small
          class="navButton text-capitalize"
          :ripple="false"
          :class="{
            'grey--text text--darken-2': $route.name != 'Pinjaman',
          }"
          color="#252525"
          v-if="widthNow > 550"
          @click="$router.push('/pinjaman')"
        >
          <p>Pinjaman</p>

          <p />
        </v-btn>
      </div> -->
      <!-- <div v-else>
        <v-btn
          plain
          x-small
          class="navButton text-capitalize"
          color="#252525"
          v-if="widthNow > 550"
          @click="$router.push('/pinjaman')"
        >
          <p>Pinjaman</p>

          <p />
        </v-btn>
      </div>-->

      <!-- <div class="btnSpacer" /> -->

      <!-- <div :class="{ borderNavButton: $route.name == 'Produk' }">
        <v-btn
          plain
          x-small
          class="navButton text-capitalize"
          :class="{
            'grey--text text--darken-1': $route.name != 'Produk',
          }"
          color="#252525"
          @click="$router.push('/produk')"
          v-if="widthNow > 550"
        >
          <p>Produk</p>

          <p />
        </v-btn>
      </div>-->

      <!-- <div class="btnSpacer" /> -->

      <div :class="{ borderNavButton: $route.name == 'Tentang Kami' }">
        <v-btn
          plain
          x-small
          class="navButton text-capitalize"
          :ripple="false"
          :class="{
            'grey--text text--darken-2': $route.name != 'Tentang Kami',
          }"
          color="#252525"
          v-if="widthNow > 550"
          @click="$router.push('/tentang-kami')"
        >
          <p>Tentang Kami</p>

          <p />
        </v-btn>
      </div>
      <!-- <div v-else>
        <v-btn
          text
          x-small
          class="navButton text-capitalize grey--text text--darken-1"
          color="#252525"
          v-if="widthNow > 550"
          @click="$router.push('/tentang-kami')"
        >
          <p>Tentang Kami</p>

          <p />
        </v-btn>
      </div>-->

      <!-- <div class="btnSpacer" /> -->

      <!-- <div :class="{ borderNavButton: $route.name == 'Karir' }">
        <v-btn
          plain
          x-small
          class="navButton text-capitalize"
          :ripple="false"
          :class="{
            'grey--text text--darken-2': $route.name != 'Karir',
          }"
          color="#252525"
          v-if="widthNow > 550"
          @click="$router.push('/career')"
        >
          <p>Karir</p>

          <p />
        </v-btn>
      </div> -->

      <div class="btnSpacer" />

      <div :class="{ borderNavButton: $route.name == 'Hubungi Kami' }">
        <v-btn
          plain
          x-small
          class="navButton text-capitalize"
          :ripple="false"
          :class="{
            'grey--text text--darken-2': $route.name != 'Hubungi Kami',
          }"
          color="#252525"
          v-if="widthNow > 550"
          @click="$router.push('/hubungi-kami')"
        >
          <p>Hubungi Kami</p>

          <p />
        </v-btn>
      </div>
      <!-- <div v-else>
        <v-btn
          plain
          x-small
          class="navButton text-capitalize"
          color="#252525"
          v-if="widthNow > 550"
          @click="$router.push('/hubungi-kami')"
        >
          <p>Hubungi Kami</p>

          <p />
        </v-btn>
      </div>-->

      <!-- <div class="btnSpacer" /> -->

      <!-- <div
        :class="{ borderNavButton: $route.name == 'Blog' }"
        :style="{ marginRight: marginRight }"
      >
        <v-btn
          plain
          x-small
          class="navButton text-capitalize"
          :ripple="false"
          :class="{
            'grey--text text--darken-2': $route.name != 'Blog',
          }"
          color="#252525"
          @click="toBlog"
          v-if="widthNow > 550"
        >
          <p>Blog</p>

          <p />
        </v-btn>
      </div> -->

      <!-- <v-spacer></v-spacer>
      <v-icon>bookmark_border</v-icon>-->
    </v-app-bar>
  </div>
</template>

<script>
import axios from "axios";
export default {
  created() {
    this.test = this.$router.currentRoute.name;
    if (window.innerWidth <= 1007) {
      this.fontSize = "40px";
    } else {
      this.fontSize = "60px";
    }
    window.addEventListener("resize", this.myEventHandler);
    //
    //
    // this.username = localStorage.getItem("name");
    // if(localStorage.getItem("token")){
    //
    // }
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  data: () => ({
    //
    marginLeft: `${window.innerWidth / 9}px`,
    marginRight: `${window.innerWidth / 9}px`,
    heightNow: window.innerHeight,
    widthNow: window.innerWidth,
    showMenu: false,
    dialog: false,
    windowSize: {
      x: 0,
      y: 0,
    },
    fontSize: "60px",
    form: "",
    name: "",
    password: "",
    widthSize: window.innerWidth - 100,
    test: "",
    newSearch: "",
    email: "",
  }),
  computed: {
    username() {
      return localStorage.getItem("name");
    },
    link() {
      return this.test;
    },
    masterData() {
      return this.$store.state.masterData;
    },
  },

  watch: {
    // link(newValue, oldValue) {
    //
    //   // Do whatever makes sense now
    // }
  },

  methods: {
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    download(url, title) {
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch(() => console.log("error occured"));
    },
    scroll() {
      document
        .querySelector("#skema")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    },
    myEventHandler() {
      if (window.innerWidth <= 1007) {
        this.fontSize = "40px";
      } else {
        this.fontSize = "60px";
      }
      this.heightNow = window.innerHeight;
      this.widthNow = window.innerWidth;
      this.marginLeft = `${window.innerWidth / 9}px`;
      this.marginRight = `${window.innerWidth / 9}px`;

      this.widthSize = window.innerWidth - 100;

      // your code for handling resize...
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    back() {
      this.$router.go(-1);
    },
    doNothing() {},
    // toBlog() {
    //   window.location = "https://blog.dompetkilat.co.id/";
    // },
  },
};
</script>

<style>
.search.v-input .v-input__slot {
  border-radius: 5px;
  height: 29px;
  font-size: 14px;
  box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.16);
}
.navbar.v-tab {
  font-size: 16px;
}
.navbar {
  font-size: 16px;
}
.no-background::before {
  background-color: transparent !important;
}
.appBar {
  height: 90px !important;
  padding-top: 1%;
}
.dkLogo {
  width: 251px;
  padding-right: 60px;
  cursor: pointer;
}
.toolbarTitle {
  font-family: "sora";
  font-weight: 1000;
  font-size: 25px;
  letter-spacing: -0.07rem;
  padding: 1px;
  position: relative;
  padding-right: 60px;
}
.tkbContainer {
  font-family: "sora";
  font-weight: 1000;
  font-size: 25px;
  padding: 14px;
  margin-bottom: 11px;
  letter-spacing: -0.07rem;
  position: relative;
}
.tkbText {
  width: 73.5px;
  height: 16.5px;
  object-fit: contain;
  font-size: 10px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.tkbPercentage {
  width: 49px;
  height: 16.5px;
  object-fit: contain;
  font-size: 12px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: left;
  color: #3bb54a;
}
.navButton {
  font-weight: 1000 !important;
  font-size: 14px !important;
  margin-top: 5px !important;
}
.btnSpacer {
  margin-right: 20px;
}
.borderNavButton {
  margin-top: 2px;
  height: 45%;
  border-bottom-style: solid;
  border-bottom-color: #d3352c;
}
@media screen and (max-width: 1342px) {
  .appBar {
    height: 80px !important;
    padding-top: 1%;
  }
  .dkLogo {
    width: 201px;
    padding-right: 40px;
    cursor: pointer;
  }
  .toolbarTitle {
    font-family: "sora";
    font-weight: 1000;
    font-size: 25px;
    letter-spacing: -0.07rem;
    padding: 1px;
    position: relative;
    padding-right: 60px;
  }
  .tkbContainer {
    font-family: "sora";
    font-weight: 1000;
    font-size: 25px;
    padding: 14px;
    margin-bottom: 11px;
    letter-spacing: -0.07rem;
    position: relative;
  }
  .tkbText {
    width: 73.5px;
    height: 16.5px;
    object-fit: contain;
    font-size: 10px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: left;
    color: #252525;
  }
  .tkbPercentage {
    width: 49px;
    height: 16.5px;
    object-fit: contain;
    font-size: 12px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: left;
    color: #3bb54a;
  }
  .navButton {
    font-weight: 1000 !important;
    font-size: 14px !important;
    margin-top: 10px !important;
  }
  .btnSpacer {
    margin-right: 20px;
  }
  .borderNavButton {
    margin-top: -2px;
    height: 50%;
    border-bottom-style: solid;
    border-bottom-color: #d3352c;
  }
}
@media screen and (max-width: 1142px) {
  .appBar {
    height: 70px !important;
    padding-top: 1%;
  }
  .dkLogo {
    width: 151px;
    padding-right: 10px;
    cursor: pointer;
  }
  .toolbarTitle {
    font-family: "sora";
    font-weight: 1000;
    font-size: 25px;
    letter-spacing: -0.07rem;
    padding: 1px;
    position: relative;
    padding-right: 60px;
  }
  .tkbContainer {
    font-family: "sora";
    font-weight: 1000;
    font-size: 25px;
    padding: 14px;
    margin-bottom: 11px;
    letter-spacing: -0.07rem;
    position: relative;
  }
  .tkbText {
    width: 63.5px;
    height: 16.5px;
    object-fit: contain;
    font-size: 9px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: left;
    color: #252525;
  }
  .tkbPercentage {
    width: 39px;
    height: 16.5px;
    object-fit: contain;
    font-size: 11px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: left;
    color: #3bb54a;
  }
  .navButton {
    font-weight: 1000 !important;
    font-size: 10px !important;
    margin-top: 10px !important;
  }
  .btnSpacer {
    margin-right: 10px;
  }
  .borderNavButton {
    margin-top: -2px;
    height: 50%;
    border-bottom-style: solid;
    border-bottom-color: #d3352c;
  }
}
@media screen and (max-width: 942px) {
  .appBar {
    height: 70px !important;
    padding-top: 1%;
  }
  .dkLogo {
    width: 151px;
    padding-right: 10px;
    cursor: pointer;
  }
  .toolbarTitle {
    font-family: "sora";
    font-weight: 1000;
    font-size: 25px;
    letter-spacing: -0.07rem;
    padding: 1px;
    position: relative;
    padding-right: 60px;
  }
  .tkbContainer {
    font-family: "sora";
    font-weight: 1000;
    font-size: 25px;
    padding: 14px;
    margin-bottom: 11px;
    letter-spacing: -0.07rem;
    position: relative;
  }
  .tkbText {
    width: 63.5px;
    height: 16.5px;
    object-fit: contain;
    font-size: 8px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: left;
    color: #252525;
  }
  .tkbPercentage {
    width: 39px;
    height: 16.5px;
    object-fit: contain;
    font-size: 10px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: left;
    color: #3bb54a;
  }
  .navButton {
    font-weight: 1000 !important;
    font-size: 9px !important;
    margin-top: 10px !important;
  }
  .btnSpacer {
    margin-right: 10px;
  }
  .borderNavButton {
    margin-top: -5px;
    height: 54%;
    border-bottom-style: solid;
    border-bottom-color: #d3352c;
  }
}
@media screen and (max-width: 842px) {
  .appBar {
    height: 70px !important;
    padding-top: 1%;
  }
  .dkLogo {
    width: 101px;
    padding-right: 10px;
    cursor: pointer;
  }
  .toolbarTitle {
    font-family: "sora";
    font-weight: 1000;
    font-size: 25px;
    letter-spacing: -0.07rem;
    padding: 1px;
    position: relative;
    padding-right: 60px;
  }
  .tkbContainer {
    font-family: "sora";
    font-weight: 1000;
    font-size: 25px;
    padding: 14px;
    margin-bottom: 11px;
    letter-spacing: -0.07rem;
    position: relative;
  }
  .tkbText {
    width: 63.5px;
    height: 16.5px;
    object-fit: contain;
    font-size: 8px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: left;
    color: #252525;
  }
  .tkbPercentage {
    width: 39px;
    height: 16.5px;
    object-fit: contain;
    font-size: 10px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: left;
    color: #3bb54a;
  }
  .navButton {
    font-weight: 1000 !important;
    font-size: 8px !important;
    margin-top: 10px !important;
  }
  .btnSpacer {
    margin-right: 10px;
  }
  .borderNavButton {
    margin-top: -5px;
    height: 54%;
    border-bottom-style: solid;
    border-bottom-color: #d3352c;
  }
}
/* .theme--light.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover{
border-width: 1px;
border-style: solid;
border-color: #6fbd44;
} */
</style>
